import DefaultDetail from "@Common/DefaultDetail";
import { inject, observer } from "mobx-react";
import "./style.scss";
import { getEditInputsByStep } from "../../config.jsx";

const Step2 = inject("mainStore")(
    observer(({ mainStore, setStep, step, countOfSteps, className = "" }) => {
        const detailData = mainStore.getMainStore("detailData");
        const input = getEditInputsByStep({ mainStore, detailData, isAdd: true }).step2 || [];

        return <DefaultDetail apiUrl={"/promo/offers"} inputs={input} page={"offers"} setStep={setStep} step={step} countOfSteps={countOfSteps} />;
    }),
);

export default Step2;
